import { useSyncExternalStore } from "react";

import { getScheme, subscribeScheme } from "@services/api";

/** The scheme selected in Zenith's app bar; null for the customer's home. */
export const useSelectedScheme = () =>
  useSyncExternalStore(subscribeScheme, getScheme);
